import AdminCategories from "@/pages/admin/Categories";

export default function AdminAdvanced() {
  return (
    <div data-testid="admin-advanced-page">
      <h1 className="font-serif text-2xl font-bold text-cream-text">Advanced Settings</h1>
      <p className="mt-1 text-sm text-cream-muted">
        Structural settings that rarely change. Order-number prefix and the weekly cut-off live under
        Business Settings → Advanced and need an extra confirmation.
      </p>
      <div className="mt-6">
        <AdminCategories />
      </div>
      <div className="mt-8 rounded-3xl border border-choco-line bg-choco-light p-6" data-testid="advanced-developer-note">
        <h2 className="font-serif text-lg font-semibold text-cream-text">Developer contact</h2>
        <p className="mt-2 text-sm text-cream-muted">
          For technical problems beyond these pages (payments connection, domain changes, email sending setup),
          contact your developer. Never share your password — they don't need it.
        </p>
      </div>
    </div>
  );
}
